export const collectSearchParams = (query: URLSearchParams) => {
  const searchParams: { [key: string]: string } = {};

  query.forEach((value, key) => {
    searchParams[key.toLowerCase()] = value;
  });

  return searchParams;
};
